import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { RiderPhoneNumberModule } from '../../rider-phone-number';
import { EditRiderDialogComponent } from './edit-rider-dialog.component';
import { RiderEmailModule } from '../../rider-email/rider-email.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { RequiresPermissionsModule } from '../../directives';
import { OrganizationRiderServiceLevelsModule } from '../../organization-rider-service-levels';
import { UzurvDirectivesModule } from '@uzurv/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActionTooltipModule } from '../../directives/action-tooltip';
import { ZipCodeDirectiveModule } from '../../directives/zipcode-directive';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatSelectModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatRadioModule,
    MatNativeDateModule,
    MatTooltipModule,
    ReactiveFormsModule,
    RiderPhoneNumberModule,
    RiderEmailModule,
    RequiresPermissionsModule,
    OrganizationRiderServiceLevelsModule,
    UzurvDirectivesModule,
    ActionTooltipModule,
    ZipCodeDirectiveModule
  ],
  exports: [EditRiderDialogComponent],
  declarations: [EditRiderDialogComponent]
})
export class EditRiderDialogModule {}
